import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./Home.css";


import { Container, Nav, Navbar, NavDropdown, Form, Button, Image, Carousel, Row, Col, Card, Tabs, Tab, Spinner, Badge } from 'react-bootstrap'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from "@fortawesome/free-solid-svg-icons";



import { firestore } from '../Database/firebase';
import { auth } from '../Database/firebase';

import { FaHeart, FaTruck, FaFacebookMessenger } from "react-icons/fa";
import { BsStarFill, BsStarHalf, BsStar, BsBagHeart } from "react-icons/bs";
import { text } from '@fortawesome/fontawesome-svg-core';
import NewReleaseBookView from './content/NewReleaseBook';
import BestSellerBookView from './content/BestSellerBook';
import SuggestionBookView from './content/SuggestionBook';



import EduLaw_home_ads01 from "../component_home/asset/EduLaw_home_ads01.JPG"
import EduLaw_home_ads02 from "../component_home/asset/EduLaw_home_ads02.JPG"
import EduLaw_home_ads03 from "../component_home/asset/EduLaw_home_ads03.JPG"


function HomeView() {
    

   /*  var user = auth.currentUser;
    
    var uid = "";

    if (user != null) {
       
        uid = user.uid;  
                     
        console.log(uid);

    } else {
       
    } */
    /* const {currentUser} = useContext(AuthContext);

    if (!currentUser) {
        return <Navigate to="/LogIn" replace />
    } */

    //Test useParams
    // let productId = "MIGhY5tyTiuRPeSWxDXC";

    const formatter = new Intl.NumberFormat('th', {
        style: 'currency',
        currency: 'THB',
        maximumSignificantDigits: 3,
        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
      });
    
    

    

    return (
        
    <div>

   {/*  <Container>

        <FlashSale/>
    
    </Container> */}

    <Container>
     {/*    <img style={{borderRadius: 5}}
        className="d-block w-100"
        src={ads_aboutus_03} fluid
        alt="First slide" /> */}
           

            <Carousel>
                <Carousel.Item>
                    <img
                    className="d-block w-100"
                    src={EduLaw_home_ads01}
                    alt="First slide"
                     style={{ width: "100%", height: "auto", objectFit: "cover" }}
                    />
                    {/* <Carousel.Caption>
                    <h3>รูปภาพที่ 1</h3>
                    <p>คำอธิบายสำหรับสไลด์ที่ 1</p>
                    </Carousel.Caption> */}
                </Carousel.Item>

                <Carousel.Item>
                    <img
                    className="d-block w-100"
                    src={EduLaw_home_ads02}
                    alt="Second slide"
                     style={{ width: "100%", height: "auto", objectFit: "cover" }}
                    />
                    {/* <Carousel.Caption>
                    <h3>รูปภาพที่ 2</h3>
                    <p>คำอธิบายสำหรับสไลด์ที่ 2</p>
                    </Carousel.Caption> */}
                </Carousel.Item>

                <Carousel.Item>
                    <img
                    className="d-block w-100"
                    src={EduLaw_home_ads03}
                    alt="Third slide"
                     style={{ width: "100%", height: "auto", objectFit: "cover" }}
                    />
                    {/* <Carousel.Caption>
                    <h3>รูปภาพที่ 3</h3>
                    <p>คำอธิบายสำหรับสไลด์ที่ 3</p>
                    </Carousel.Caption> */}
                </Carousel.Item>
            </Carousel>

            <br/>


                <NewReleaseBookView/>

            <br/>
            <br/>

            <div id="grad1" class="line"></div>

            <br/>
          

                <img
                    className="d-block w-100"
                    src={EduLaw_home_ads02}
                    alt="Second slide"
                     //style={{ width: "100%", height: "auto", objectFit: "cover" }}
                />

                <br/>
            
                <BestSellerBookView/>
           

            <br/>
            <br/>

            <div id="grad1" class="line"></div>

            <br/>
            

             
                <img
                    className="d-block w-100"
                    src={EduLaw_home_ads03}
                    alt="Second slide"
                     //style={{ width: "100%", height: "auto", objectFit: "cover" }}
                />

                <br/>
            
                <SuggestionBookView/>
           

            <br/>
            <br/>

            {/* <div id="grad1" class="line"></div>

            <br/>
            <br/>

            <div className="borderarticle">
                <GameArticleCategory/>
            </div>
            

            <br/>
            <br/>

            <div id="grad1" class="line"></div>

            <br/>
            <br/>

            <div className="borderarticle">
                
                <PlantArticleCategory/>
            </div>

            <br/>
            <br/>

            <div id="grad1" class="line"></div>

            <br/>
            <br/>

            <div className="borderarticle">
                <ComputerArticleCategory/>
            </div>
            
            <br/>
            <br/>

            <div id="grad1" class="line"></div>

            <br/>
            <br/>

            <div className="borderarticle">
                <GeneralArticleCategory/>
            </div>

            <br/>
            <br/>

            <div id="grad1" class="line"></div>

           <br/>

                <AllArticle/> */}

            <br/>
            <br/>
            
            

    </Container>

    
    </div>

  );
}

export default HomeView;